<script>
    export let color
</script>

<svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="25" height="2.5" fill={color}/>
    <rect x="0.5" y="7.55078" width="12.5" height="2.5" fill={color}/>
    <rect x="0.5" y="14.6025" width="25" height="2.5" fill={color}/>
</svg>
    